import { render, staticRenderFns } from "./RawShipments.vue?vue&type=template&id=fc68b836&"
import script from "./RawShipments.vue?vue&type=script&lang=js&"
export * from "./RawShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RawShipments.vue"
export default component.exports